import { v1ApiClient } from '@/services';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

import type { CreateChartPayload } from './types';

export const createChart = async (
  chartState: CreateChartPayload,
): Promise<ChartItem> => {
  const wa = getCurrWorkspaceAlias();
  const res = await v1ApiClient.post(`/workspaces/${wa}/charts`, chartState);
  return res.data;
};
